// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"501":"04d72845","778":"cc281fd1","964":"e15f32b5"}[chunkId] + ".chunk.css";
};